/**
 * useOnboarding — B-2026-0078
 *
 * React Query hook for the athlete's onboarding checklist state.
 * Data is fetched on mount (staleTime 30 s) and re-fetched when the window
 * regains focus so the checklist auto-updates after the athlete submits an eval
 * and returns to the dashboard.
 */

import { useQuery } from '@tanstack/react-query';
import { getOnboardingStatus } from '@/services/onboardingApi';
import { useAuth } from '@/contexts/AuthContext';

export const ONBOARDING_QUERY_KEY = 'onboarding-status' as const;

export function useOnboardingStatus() {
  const { user } = useAuth();
  return useQuery({
    queryKey: [ONBOARDING_QUERY_KEY, user?.id],
    queryFn: getOnboardingStatus,
    enabled: !!user?.id,
    staleTime: 30_000,
    // Refetch on focus so the checklist updates after the athlete returns from
    // the evaluation page.
    refetchOnWindowFocus: true,
  });
}
